export default __webpack_public_path__ + "static/media/89.98e130b5.jpg";